<template>
  <div>
    <Drawer
      :title="changeModalTitle"
      v-model="changeModal"
      width="800"
      @on-cancel="formReset"
      :mask-closable="true">
      <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
      <Form :model="changeForm" ref="changeForm" :rules="changeRule">
        <FormItem prop="name" label="备份名称">
          <Input v-model="changeForm.name" placeholder="填写备份名称" :maxlength="128" />
        </FormItem>
        <FormItem prop="description" label="描述">
          <Input v-model="changeForm.description" type="textarea" :rows="4" :maxlength="255" />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="changeSubmit" :loading="changeLoading">提交</Button>
          <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
        </FormItem>
      </Form>
    </Drawer>
  </div>
</template>

<script>
import { changePrivateCloudVolumeBackup } from '@/api/private-cloud/volume-backup'
export default {
  name: 'backup-edit',
  data () {
    return {
      changeModalTitle: '创建卷备份',
      changeModal: false,
      changeLoading: false,
      changeForm: {
        id: '',
        name: '',
        description: ''
      },
      changeRule: {
        name: [
          { required: true, message: '备份名称不能为空', trigger: 'blur' }
        ]
      },
      volume_id: '',
      errorMsg: '',
      errorMsgShow: false
    }
  },
  methods: {
    init () {
      this.formReset()
    },
    // 打开创建模式
    openModal (volumeId) {
      this.volume_id = volumeId
      this.init()
      this.changeModalTitle = '创建卷备份'
      this.changeModal = true
    },
    // 打开修改模式
    modifyOpenModal (row) {
      this.init()
      this.changeForm.id = row.id
      this.changeForm.name = row.name
      this.changeForm.description = row.description
      this.changeModalTitle = '[' + row.name + '] 编辑'
      this.changeModal = true
    },
    // 通用表单重置
    formReset () {
      this.changeForm = {
        id: '',
        name: '',
        description: ''
      }
    },
    // 提交卷备份编辑表单
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            name: this.changeForm.name,
            description: this.changeForm.description
          }
          if (!this.changeForm.id) {
            reqData.volume_id = this.volume_id
          }
          this.changeLoading = true
          changePrivateCloudVolumeBackup(reqData, this.changeForm.id).then(res => {
            this.errorMsgShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.$emit('editComplete')
            this.changeModal = false
            this.formReset()
            this.changeLoading = false
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
